import bytes from "bytes";

// FIXME: this is also on the backend. To make sure it's coherent,
// this should go to dynamo + microsite settings on publish, instead
export const MAX_FILE_SIZES: Record<string, number> = {
  video: bytes(import.meta.env.FOOJI_VIDEO_UPLOAD_LIMIT as string) ?? 200 * 1024 * 1024,
  image: bytes(import.meta.env.FOOJI_IMAGE_UPLOAD_LIMIT as string) ?? 6 * 1024 * 1024,
  default: bytes(import.meta.env.FOOJI_DEFAULT_UPLOAD_LIMIT as string) ?? 6 * 1024 * 1024
};
